import React from 'react';
import { useSelector } from 'react-redux';
import { FLOWS_ENUM } from '../../common/enums';
import { selectRenewalPermitData } from '../../store/slices/renew/renewSelectors';
import { ApplicationData } from 'src/types/flow';
import { RegistrantPage } from 'src/components/pages/RegistrantPage';
import { updatePermitData } from 'src/store/slices/renew/renewSlice';

const RenewRegistrant = () => {
  const data = useSelector(selectRenewalPermitData) as ApplicationData;
  return (
    <RegistrantPage
      data={data}
      flow={FLOWS_ENUM.RENEW_LICENSE}
      updatePermitData={updatePermitData}
    />
  );
};

export default RenewRegistrant;
